// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"157":"pages/Game","336":"pages/Home","525":"pages/PreGame"}[chunkId] || chunkId) + "-legacy." + {"157":"44ddf7ce","203":"19e48b0a","336":"242e30d6","522":"d50f9131","525":"c19e3c85"}[chunkId] + ".js";
};